import { createFileRoute } from '@tanstack/react-router'
import { VirtualReportsListPage } from 'pages/virtualReports/VirtualReportsListPage'

export const Route = createFileRoute('/virtual-reports/{-$siteID}/')({
  component: RouteComponent,
  staticData: {
    title: 'Virtual Reports',
  },
})

function RouteComponent() {
  return <VirtualReportsListPage />
}
